class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }


  event(){
    const targets = document.querySelectorAll('.s-parallax img');

    window.addEventListener('scroll', () => {
      targets.forEach((img) => {
        const parent = img.closest('.s-parallax');
        if (!parent) return;
    
        const rect = parent.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const isSp = window.innerWidth <= 767;
        const basePoint = isSp ? windowHeight -200 : windowHeight - 200;
    
        if (rect.top < basePoint) {
          const progress = Math.min((basePoint - rect.top) / rect.height, 1);
          const startY = isSp ? -14 : -20;
    
          const slowProgress = progress * 0.4; // スピードゆっくり（0.4倍）
          const translateY = startY + (-startY * slowProgress);
    
          img.style.transform = `translate(-50%, ${translateY}%)`;
        }
      });
    });

    // MV Swiper
    const mvSwiper = new Swiper('.mv-swiper', { // ←全mvの部分固有名に変える
      loop: true, 
      loopAdditionalSlides: 1, // ←ループモード時に複製するスライド数指定。基本的に1以上で設定しておく。
      slidesPerView: 1, // ←表示数
      centeredSlides: true, // ←センタースライド
      slidesOffsetBefore: 18, // ←パディング
      slidesOffsetAfter: 18, // ←パディング
      effect: 'fade', // ←追加 フェード機能をONにする
    
      speed: 2500, // ←切り替わるときの動きのスピード
      autoplay: { // ←自動再生
        delay: 4000, // 次のスライドに切り替わるまでの時間を指定(40秒)
        disableOnInteraction: false, // ←false にすればユーザーがドラッグなどの操作をしても自動再生が止まらない
      },
    
      breakpoints: { // ←ブレークポイント
        789: { // ←画面幅このpx以上
          slidesPerView: 1,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
      },
    });

    const megaSwiper = new Swiper('.mega-swiper', { // ←全megaの部分固有名に変える
      loop: true, 
      loopAdditionalSlides: 1, // ←ループモード時に複製するスライド数指定。基本的に1以上で設定しておく。
      slidesPerView: 1, // ←表示数
      spaceBetween: 12, // ←間隔(gap)
      centeredSlides: true, // ←センタースライド
    
      autoplay: { // ←自動再生
        disableOnInteraction: false, // ←false にすればユーザーがドラッグなどの操作をしても自動再生が止まらない
      },
    });


    // // Course Menu Swiper
    // const dinnerimgSwiper = new Swiper('.dinnerimg-swiper', { // ←全dinnerimgの部分固有名に変える
    //   loop: true, 
    //   loopAdditionalSlides: 1, // ←ループモード時に複製するスライド数指定。基本的に1以上で設定しておく。
    //   slidesPerView: 1, // ←表示数
    //   spaceBetween: 12, // ←間隔(gap)
    //   centeredSlides: true, // ←センタースライド
    //   effect: 'fade',
    //   fadeEffect: {
    //     crossFade: true
    //   },
    
    //   speed: 1000, // ←切り替わるときの動きのスピード
    //   autoplay: { // ←自動再生
    //     delay: 3000, // 次のスライドに切り替わるまでの時間を指定(40秒)
    //     disableOnInteraction: false, // ←false にすればユーザーがドラッグなどの操作をしても自動再生が止まらない
    //   },
    //   pagination: {
    //     el: '.dinnerimg-swiper-pagination',
    //     type: 'custom',
    //     renderCustom: function (swiper, current, total) {
    //       // 現在のページ番号を2桁で表示（01, 02, 03...）
    //       const currentPage = String(current).padStart(2, '0');
    //       // 総ページ数を2桁で表示
    //       const totalPages = String(total).padStart(2, '0');
    //       return `${currentPage} / ${totalPages}`;
    //     }
    //   },
    // });

    // const dinnertxtSwiper = new Swiper('.dinnertxt-swiper', { // ←全dinnertxtの部分固有名に変える
    //   loopAdditionalSlides: 1, // ←ループモード時に複製するスライド数指定。基本的に1以上で設定しておく。
    //   slidesPerView: 1, // ←表示数
    //   effect: 'fade',
    //   fadeEffect: {
    //     crossFade: true
    //   },
      
    //   speed: 1000, // ←切り替わるときの動きのスピード
    //   autoplay: { // ←自動再生
    //     delay: 3000, // 次のスライドに切り替わるまでの時間を指定(40秒)
    //   },
    // });

    // // dinnerimg-swiperからdinnertxt-swiperへの連動
    // dinnerimgSwiper.on('slideChangeTransitionStart', () => {
    //   dinnertxtSwiper.slideToLoop(dinnerimgSwiper.realIndex);
    // });

    // // dinnertxt-swiperからdinnerimg-swiperへの連動
    // dinnertxtSwiper.on('slideChangeTransitionStart', () => {
    //   dinnerimgSwiper.slideToLoop(dinnertxtSwiper.realIndex);
    // });

    
  }
}
